import React, { useEffect, useState } from "react";
import whoImage1 from '../images/about-picture.jpg';
import whoImage2 from '../images/about-picture2.jpg';
import whoImage3 from '../images/about-picture3.jpg';
import whoImage4 from '../images/image.png';

export default function Example() {


  return (
    <div className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div
            className="mx-auto my-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2"
          >
              <>
                {/* Text on the left, image on the right for even indexes */}
                <div className="lg:pr-8 lg:pt-4">
                  <div className="lg:max-w-lg">
                    <h2 className="text-base font-semibold text-indigo-600">About Us</h2>
                    <p className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                    Who we are & what we do
                    </p>
                    <p className="mt-6 text-lg text-gray-600">We draw together SEND expertise in SEN, Short Breaks, Social Services, Early Help and more. We are aiming to better the lives of families, champion quality SEND provision and improve local authority services. Ensuring inclusivity is at the heart of everything we do.</p>
                  </div>
                </div>
                <img
                  alt="Product screenshot"
                  src={whoImage1}
                  width={2432}
                  height={1442}
                  className="w-full max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 md:w-[32rem] lg:w-[36rem] md:-ml-4 lg:-ml-0"
                />


            <div className="lg:pr-8 lg:pt-4">
                  <div className="lg:max-w-lg">
                   
                    <p className="mt-6 text-lg text-gray-600">

                    Our vision is lasting change – breaking down the barriers to support, providing opportunities to everyone, transform the current SEND landscape and create a unique space for the SEND community. Find our more here (link to About page)

                    </p>
                  </div>
                </div>
                <img
                  alt="Product screenshot"
                  src={whoImage2}
                  width={2432}
                  height={1442}
                  className="w-full max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 md:w-[32rem] lg:w-[36rem] md:-ml-4 lg:-ml-0"
                />

<div className="lg:pr-8 lg:pt-4">
                  <div className="lg:max-w-lg">
                   
                    <p className="mt-6 text-lg text-gray-600">

                    We enable partnership working with parents, carers and professionals with specialist advice, guidance and support.  
                    </p>
                  </div>
                </div>
                <img
                  alt="Product screenshot"
                  src={whoImage3}
                  width={2432}
                  height={1442}
                  className="w-full max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 md:w-[32rem] lg:w-[36rem] md:-ml-4 lg:-ml-0"
                />


<div className="lg:pr-8 lg:pt-4">
                  <div className="lg:max-w-lg">
                   
                    <p className="mt-6 text-lg text-gray-600">

                    Exclusive discounts and offers on SEND products, services and much more. 
                    </p>
                  </div>
                </div>
                <img
                  alt="Product screenshot"
                  src={whoImage4}
                  width={2432}
                  height={1442}
                  className="w-full max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 md:w-[32rem] lg:w-[36rem] md:-ml-4 lg:-ml-0"
                />
              </>
              </div>




      </div>
    </div>
  );
}
